import { computed } from 'vue';
import type { ComputedRef, Ref } from 'vue';

import { CCM_MODE } from '@/components/map/cnetConstructorMode/ccmConsts';
import { MAP_MODE, FEATURE_TYPE } from '@/components/map/consts/mapFeatureConsts';
import type { FeatureType, MapMode } from '@/components/map/types/mapFeatureTypes';


export type MapAllowedFeatureTypesStore = {
	mode: MapMode;
};


export function useAllowedHoverTypes(
	baseStationsStore: MapAllowedFeatureTypesStore,
	cnetConstructorDrawMode: Ref<number>,
): ComputedRef<readonly FeatureType[]> {
	return computed((): readonly FeatureType[] => {
		if (baseStationsStore.mode === MAP_MODE.gnssPerGridpoint) {
			return [];
		}
		if (baseStationsStore.mode === MAP_MODE.cnetConstructor) {
			if (cnetConstructorDrawMode.value === CCM_MODE.selectGridpoints) {
				return [FEATURE_TYPE.cnetConstructorGridpoint];
			}
			return [];
		}
		if (baseStationsStore.mode === MAP_MODE.roversHistory) {
			return [
				FEATURE_TYPE.roverHistoryCurrent,
				FEATURE_TYPE.roverHistoryFragment,
			];
		}
		if (baseStationsStore.mode === MAP_MODE.coverage) {
			return [
				FEATURE_TYPE.qualityRectangle,
			];
		}
		return [
			FEATURE_TYPE.baseStation,
			FEATURE_TYPE.vrsStation,
			FEATURE_TYPE.getterActive,
			FEATURE_TYPE.getterFailed,
			FEATURE_TYPE.baselineLinkLine,
			FEATURE_TYPE.baselineLinkSelfCircle,
			FEATURE_TYPE.baselineLinkArrowHead,
		];
	});
}


export function useAllowedClickTypes(
	baseStationsStore: MapAllowedFeatureTypesStore,
): ComputedRef<readonly FeatureType[]> {
	return computed((): readonly FeatureType[] => {
		if (baseStationsStore.mode === MAP_MODE.coverage) {
			return [];
		}
		if (baseStationsStore.mode === MAP_MODE.cnetConstructor) {
			return [
				FEATURE_TYPE.cnetConstructorGridpoint,
			];
		}
		return [
			FEATURE_TYPE.baseStation,
			FEATURE_TYPE.baselineLinkSelfCircle,
			FEATURE_TYPE.baselineLinkLine,
			FEATURE_TYPE.baselineLinkArrowHead,
		];
	});
}
